import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@material-ui/core";
import { SetChargePackage } from "../../../redux/chargePackage/actions";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import * as img from "../../../assets/images"

const ChargeView = () => {
  // --------- states
  const [active, setActive] = useState<any>({
    gas: 1,
    water: 1,
    phone: 1,
    static: 1,
    custom: 1,
    electric: 1
  });

  //---------- end states

  // --------- variables
  const dispatch = useDispatch()
  const history = useHistory()
  const images = {
    gas: {
      1: img.Gas,
      2: img.GasA,
    },
    water: {
      1: img.Water,
      2: img.WaterA
    },
    phone: {
      1: img.Mobile,
      2: img.MobileA
    },
    static: {
      1: img.Phone,
      2: img.PhoneA
    },
    custom: {
      1: img.Barcode,
      2: img.BarcodeA
    },
    electric: {
      1: img.Electricity,
      2: img.ElectricityA
    }
  };

  // --------- end variables

  // --------- useEffects
  useEffect(() => {
    // clear infos
    dispatch(SetChargePackage({}))
  }, [])
  // --------- end useEffects

  // --------- functions

  // set bill type and redirect
  const billTypeHandler = (type: number) => {
    dispatch(SetChargePackage({ billType: type }))
    history.push('/billInfo')
  }

  const handleActive = (name: string, value: number) => {
    setActive({
      ...active,
      [name]: value,
    });
  };

  return (
    <>
      {/* @ts-ignore */}
      <Box className="dir box mainBox p-res centerinput">
        <Grid container spacing={5} className="mt-1">
          <Grid item xs={6} md={6} lg={4}>
            <div className="bill-type-box" onClick={() => billTypeHandler(1)}
              onMouseEnter={() => handleActive("phone", 2)}
              onMouseLeave={() => handleActive("phone", 1)}
            >
              {/* @ts-ignore */}
              <Box display={"flex"} flexDirection="column" justifyContent={"center"} alignItems="center" style={{ height: "100%" }}>
                <div className="bill-type-box__icon">
                  {/* @ts-ignore */}
                  <img src={images.phone[active.phone]} alt="" />
                </div>
                <Typography>تلفن همراه</Typography>
              </Box>
            </div>
          </Grid>
          <Grid item xs={6} md={6} lg={4}>
            <div className="bill-type-box" onClick={() => billTypeHandler(2)}
              onMouseEnter={() => handleActive("static", 2)}
              onMouseLeave={() => handleActive("static", 1)}>
              {/* @ts-ignore */}
              <Box display={"flex"} flexDirection="column" justifyContent={"center"} alignItems="center" style={{ height: "100%" }}>
                <div className="bill-type-box__icon"


                >
                  {/* @ts-ignore */}
                  <img src={images.static[active.static]} alt="" />
                </div>
                <Typography>تلفن ثابت</Typography>
              </Box>
            </div>
          </Grid>
          <Grid item xs={6} md={6} lg={4}>
            <div className="bill-type-box" onClick={() => billTypeHandler(3)}
              onMouseEnter={() => handleActive("electric", 2)}
              onMouseLeave={() => handleActive("electric", 1)}>
              {/* @ts-ignore */}
              <Box display={"flex"} flexDirection="column" justifyContent={"center"} alignItems="center" style={{ height: "100%" }}>
                <div className="bill-type-box__icon"


                >
                  {/* @ts-ignore */}
                  <img src={images.electric[active.electric]} alt="" />
                </div>
                <Typography>برق</Typography>
              </Box>
            </div>
          </Grid>
          <Grid item xs={6} md={6} lg={4}>
            <div className="bill-type-box" onClick={() => billTypeHandler(4)}
              onMouseEnter={() => handleActive("gas", 2)}
              onMouseLeave={() => handleActive("gas", 1)}>
              {/* @ts-ignore */}
              <Box display={"flex"} flexDirection="column" justifyContent={"center"} alignItems="center" style={{ height: "100%" }}>
                <div className="bill-type-box__icon"


                >
                  {/* @ts-ignore */}
                  <img src={images.gas[active.gas]} alt="" />
                </div>
                <Typography>گاز</Typography>
              </Box>
            </div>
          </Grid>
          <Grid item xs={6} md={6} lg={4}>
            <div className="bill-type-box" onClick={() => billTypeHandler(5)}
              onMouseEnter={() => handleActive("water", 2)}
              onMouseLeave={() => handleActive("water", 1)}>
              {/* @ts-ignore */}
              <Box display={"flex"} flexDirection="column" justifyContent={"center"} alignItems="center" style={{ height: "100%" }}>
                <div className="bill-type-box__icon"


                >
                  {/* @ts-ignore */}
                  <img src={images.water[active.water]} alt="" />
                </div>
                <Typography>آب</Typography>
              </Box>
            </div>
          </Grid>
          <Grid item xs={6} md={6} lg={4}>
            <div className="bill-type-box" onClick={() => billTypeHandler(6)}
              onMouseEnter={() => handleActive("custom", 2)}
              onMouseLeave={() => handleActive("custom", 1)}>
              {/* @ts-ignore */}
              <Box display={"flex"} flexDirection="column" justifyContent={"center"} alignItems="center" style={{ height: "100%" }}>
                <div className="bill-type-box__icon"


                >
                  {/* @ts-ignore */}
                  <img src={images.custom[active.custom]} alt="" />
                </div>
                <Typography>پرداخت با شناسه</Typography>
              </Box>
            </div>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ChargeView;
